"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorHelperStyle = void 0;

var _utils = require("../../utils");

var _colors = require("../colors");

var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var colorHelperStyle = function colorHelperStyle(color) {
  return (0, _utils.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", " !important;\n"])), _colors.Colors[color]);
};

exports.colorHelperStyle = colorHelperStyle;